module.exports = __webpack_public_path__ + "img/function-icon2.2759b9be.png";